'use client'

import { Checkbox } from '@ui/components/shadcn/ui/checkbox'

import { BaseFieldProps, FieldShell } from './FieldShell'

export function CheckboxField({
  orientation = 'horizontal',
  ...shell
}: BaseFieldProps & { orientation?: 'vertical' | 'horizontal' }) {
  return (
    <FieldShell<boolean> orientation={orientation} {...shell}>
      {({ field, controlProps }) => (
        <Checkbox
          {...controlProps}
          checked={field.state.value}
          onCheckedChange={(checked) => field.handleChange(checked === true)}
          onBlur={field.handleBlur}
        />
      )}
    </FieldShell>
  )
}
